function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductSchema(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(40.784314%,38.431373%,46.27451%)",
      fillOpacity: 1
    },
    d: "M 15.164062 6.125 C 15.164062 4.726562 12.800781 3.542969 10 3.542969 C 7.199219 3.542969 4.832031 4.726562 4.832031 6.125 L 4.832031 7.417969 C 4.832031 8.816406 7.199219 10 10 10 C 12.800781 10 15.164062 8.816406 15.164062 7.417969 Z M 10 14.519531 C 7.199219 14.519531 4.832031 13.335938 4.832031 11.9375 L 4.832031 13.875 C 4.832031 15.273438 7.199219 16.457031 10 16.457031 C 12.800781 16.457031 15.164062 15.273438 15.164062 13.875 L 15.164062 11.9375 C 15.164062 13.335938 12.800781 14.519531 10 14.519531 Z M 10 14.519531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(40.784314%,38.431373%,46.27451%)",
      fillOpacity: 1
    },
    d: "M 15.164062 8.707031 C 15.164062 10.109375 12.800781 11.292969 10 11.292969 C 7.199219 11.292969 4.832031 10.109375 4.832031 8.707031 L 4.832031 10.644531 C 4.832031 12.046875 7.199219 13.230469 10 13.230469 C 12.800781 13.230469 15.164062 12.046875 15.164062 10.644531 Z M 15.164062 8.707031 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductSchema);
export default __webpack_public_path__ + "static/media/product_schema.5a26c59c35437e05cd00d64c5569e4ff.svg";
export { ForwardRef as ReactComponent };